import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
import { determineConsoleVersionRouteGuard } from '../../guards/determineConsoleVersionRouteGuard';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';
import { determineLanguageGuard } from '../../guards/determineLanguageGuard';

import type { AnyOfGuard } from '../../../types';

const baseGuardArray = [
  combineGuardsSerial([determineConsoleVersionRouteGuard]),
  combineGuardsSerial([determineLanguageGuard]),
  combineGuardsSerial([determineI18nResourceGuard]),
];

export const generateRouteServerSideGuards = (additionalGuards?: AnyOfGuard[]) => {
  return combineGuardsSerial([...baseGuardArray, combineGuardsSerial(additionalGuards || [])]);
};
